module.exports = __webpack_public_path__ + "static/media/repeat-1.c999971a.svg";